module.exports = __webpack_public_path__ + "static/img/image45.3ef43d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/image45.jpg
// module id = ZXKP
// module chunks = 1